'use client';

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import TogglePillGroup from 'components/consumer/TogglePillGroup';
const CategoryAlgoliaMobileFacetFilter = ({
  attribute,
  label,
  options = [],
  selectedValues = new Set(),
  onToggle
}) => {
  const selectedItems = useMemo(() => options.filter(option => selectedValues.has(option.label)).map(option_0 => option_0.label), [options, selectedValues]);
  if (!options.length) {
    return null;
  }
  return <TogglePillGroup items={options.map(option_1 => ({
    id: option_1.label,
    label: option_1.label,
    onClick: () => onToggle(attribute, option_1.label)
  }))} selectedItems={selectedItems} groupName={label} bindValues />;
};
CategoryAlgoliaMobileFacetFilter.propTypes = {
  attribute: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  selectedValues: PropTypes.instanceOf(Set).isRequired,
  onToggle: PropTypes.func.isRequired
};
export default CategoryAlgoliaMobileFacetFilter;